export const EnumEventTypes = {
  CHANGE: 'onchange',
  INIT: 'oninit',
  CLICK: 'onclick'
} as const

export type EnumEventTypes = (typeof EnumEventTypes)[keyof typeof EnumEventTypes]
